<template>
    <div>
        <div class="xinz">
            <div class="right">
                <router-link tag='a' :to="'/feedAdd'" style="text-decoration: none;color: #fff;"><el-button type="warning" v-if="canAdd" ><i class="fa fa-plus" /> {{$t('m.t_newFeedBack')}}</el-button></router-link>
            </div>
        </div>
        <div>
            <el-form :inline="true"  class="demo-form-inline" @keyup.native.enter="getFeedBackList" size="small">
                <el-form-item label="車號">
                    <el-input placeholder="車號"  v-model="serchCarNumber" clearable>
                    </el-input>
                </el-form-item>
                <el-form-item >
                    <el-date-picker
                            v-model="getFeedDate"
                            type="date"
                            placeholder="選擇日期"
							
							>
                    </el-date-picker>
                </el-form-item>
                <el-form-item >
                    <el-select v-model="serchStatus" placeholder="狀態" style="width:150px;" clearable>
                        <el-option value="0" label="未入倉"></el-option>
                        <el-option value="1" label="已入倉"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getFeedBackList()"><i class="fa fa-search" /> {{$t('m.b_query')}}</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <el-table :header-cell-style="{background:'#4B78FF',color:'#FFFFFF'}"
                    v-loading="tableloading"
                    @selection-change="handleSelectionChange"
                    :data="custTaskList"
                    :empty-text="$t('m.t_nodata')"
                    stripe
                    border
                    class="dataListTable">

                <el-table-column
                        prop="title"
                        align="left"
                        label="標題">
                </el-table-column>
                <el-table-column
                        prop="carNumber"
                        align="left"
                        label="車號">
                </el-table-column>
                <el-table-column
                        prop="feedDate"
                        align="left"
                        width="110"
                        :label="$t('m.t_date')">
                    <template slot-scope="scope">
                        <template v-if="scope.row.feedDate!=0">
                            {{scope.row.feedDate*1000 | date('%Y-%m-%d') }}
                        </template>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="status"
                        align="left"
                        width="90"
                        label="狀態">
                    <template slot-scope="scope">
                        <template v-if="scope.row.status==0">
                            未入倉
                        </template>
                        <template v-if="scope.row.status==1">
                            已入倉
                        </template>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="id"
                        align="center"
                        width="100"
                        :label="$t('m.b_opt')">
                    <template slot-scope="scope">
                        <template>
                            <el-dropdown>
                                <el-button size="small" type="primary">
                                    <i class="fa fa-mouse-pointer"/> {{$t('m.b_opt')}}
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item size="small" type="primary" @click.native="feedBackEdit(scope.row)" v-if="canEdit"><i class="fa fa-edit"/>{{$t('m.b_edit')}}</el-dropdown-item>
                                    <el-dropdown-item  @click.native="pdfDownload(scope.row)" v-if="canPdf"><i class="fa fa-file-pdf-o"/>PDF</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination
                    layout="total, prev, pager, next"
                    @current-change="custTaskPageChange"
                    :current-page.sync="pager.page"
                    :page-size="pager.size"
                    :total="pager.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import {getFeedBackList} from '../api/api'
    export default {
        data() {

            return {
                pickerOptions0:{
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                //查詢條件
                serchCarNumber:"",
                serchStatus:'',
                getFeedDate:'',
                selectionItems:[],
                pager:{
                    page:0,
                    size:10,
                    total:0
                },
                custTaskList:[],
                dialogName:'',
                tableloading:false,
            }
        },
        methods: {
            pdfDownload(value){
                var url=axios.defaults.baseURL+"/excel/feedStock?feedId="+value.id+"&token="+ this.$store.getters.staff.token;
                window.location.href=url;
            },
            handleSelectionFileChange(){},
            handleFileListChange(val){
            },

            custTaskPageChange(val){
                this.getFeedBackList();
            },handleItemChange(val){
            },
            handleSelectionChange(val){
                this.selectionItems=val;
            },
            getFeedBackList(){
                this.tableloading=true;
                var params={page:this.pager.page,size:this.pager.size,carNumber:this.serchCarNumber.trim(),feedDate:this.getFeedDate,status:this.serchStatus};
                if(params.feedDate!=null && params.feedDate!=''){
                    params.feedDate = parseInt(new Date(params.feedDate).getTime()/1000);
                }
                return getFeedBackList(params).then(data=>{
                    let {data:res={}}=data;
                    if(res.errcode==200){
                        let {size,page,total,data:items=[]}=res.data;
                        this.custTaskList=items;
                        this.pager.total=total;
                        this.pager.page=page;
                        this.pager.size=size;
                        this.tableloading=false;
                    }else{
                        this.$message.error(res.errmsg);
                    }
                });
            },
            feedBackEdit(row){
                this.$router.push({
                    name:'編輯回料纸',
                    params:{
                        feedId:row.id
                    }
                })
                var path="/feedEdit/"+row.id
                this.$router.push(path);
            },
            resetForm(formName){
                if (this.$refs[formName]!==undefined) {
                    this.$refs[formName].resetFields();
                }
            }
        },
        mounted() {
        },
        activated(){
            this.getFeedBackList();

        },
        computed: {
            canAdd(){
                return this.$store.getters.hasPermission("FEED_ADD");
            },
            canEdit(){
                return this.$store.getters.hasPermission("FEED_EDIT");
            },
            canPdf(){
                return this.$store.getters.hasPermission("FEED_PDF");
            },
        }
    }

</script>

<style lang="scss">
    .menu{
        .right{
            float: right;
        }
    }
    .el-tag + .el-tag {
        margin-left: 5px;
    }
    .dataListTable .cell{ white-space:nowrap; }
</style>



// WEBPACK FOOTER //
// src/views/FeedBackList.vue